import { render, staticRenderFns } from "./MarkdownChart.vue?vue&type=template&id=8b3649f8&scoped=true"
import script from "./MarkdownChart.vue?vue&type=script&lang=js"
export * from "./MarkdownChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3649f8",
  null
  
)

export default component.exports